import { MSClarityAnalyticsTrackerConfiguration, TrackerFactory, TrackerType, TrackingService } from "@trustedshops/tswp-core-analytics";
import Clarity from '@microsoft/clarity';
import { LogService, InvalidOperationError, EventSubscription } from "@trustedshops/tswp-core-common";
import { IdentityService } from "@trustedshops/tswp-core-authorization";


export class MSClarityAnalyticsTrackerFactory implements TrackerFactory<TrackerType.MSClarityAnalytics> {

  public get type(): TrackerType {
    return TrackerType.MSClarityAnalytics;
  }

  public constructor(
    private readonly _document: Document,
    private readonly _logService: LogService,
    private readonly _identityService: IdentityService
  ) { }

  public create(_: TrackingService, config: MSClarityAnalyticsTrackerConfiguration) {
    if (!this._document.defaultView) {
      throw new InvalidOperationError(`Registering MS Clarity Analytics in a non-browser environment is not supported.`);
    }

    this._logService.debug(
      '@trustedshops/tswp-core-analytics:MSClarityAnalyticsTrackerFactory',
      `Creating event tracker instance.`, config);

    Clarity.init(config.projectId);

    // Set user ID using the same
    this.setupUserIdentification();

    return undefined;
  }

  private setupUserIdentification(): void {
    // this is needed to not pollute the space
    (() => {
      let subscription: EventSubscription<any> | null = this._identityService.identity.subscribe(identity => {
        if (!identity) {
          return;
        }

        interface TokenPayload {
          identityRef?: string;
          'https://etrusted.com'?: {
            accountRef?: string;
          };
        }

        let payloadSubscription: EventSubscription<TokenPayload> | null = identity.profile.keycloak.token.payload.subscribe((payload: TokenPayload) => {
          if (!payload) {
            return;
          }

          const identityRef: string = payload.identityRef ?? 'unknown';
          const accountRef: string = payload['https://etrusted.com']?.accountRef ?? 'unknown';

          Clarity.setTag('userID', identityRef);
          Clarity.setTag('accountRef', accountRef);

          if (subscription) {
            subscription.unsubscribe();
            subscription = null;
          }

          if (payloadSubscription) {
            payloadSubscription.unsubscribe();
            payloadSubscription = null;
          }
        });
      });
    })();
  }
}
